import { Component, ojs, app, each, payload, State } from "modular-openscriptjs";
import {
	either,
	empty,
	oneOf,
	formatThousand,
	monetary,
	redirect,
	lastOf
} from "../../../helpers";

const h = app("h");
const gc = app("gc");
const broker = app("broker");
const $e = app("$e");
const route = app("router");

export default class MainErrandView extends Component {
	render(productState, ...args) {
		let product = productState;

		if (productState instanceof State) {
			product = productState.value;
		}

		if (!product?.id) return h.empty();

		let user = product?.owner;

		if (product?.is_copied) {
			user = product?.copier;
		}

		return h.div(
			{
				class: "d-flex p-0 gap-0 position-relative flex-column",
				data_product_id: product?.id,
				$data_product_id: product?.id,
			},

			h.div(
				{ class: "d-flex mb-3 p-0 gap-3 position-relative" },
				h.div(
					{ class: "" },
					h.ProfilePic(
						gc.user,
						h.call(() => {
							let path = gc.user?.value?.profile_photo_path;

							if (user?.id != gc.user?.id) {
								path = user?.profile_photo_path;
							}

							return h.img(
								{
									class: "rounded-circle d-block border",
									style: "max-width: 40px; height: auto",
									id: "user-profile-avatar",
								},

								either(
									path,
									{
										src: path,
										onclick: h.func(
											"broker.send",
											$e.image.needs.view,
											payload({ sources: [path] })
										),
									},
									{ src: "/assets/images/user-avatar.png" }
								)
							);
						})
					)
				),
				h.div(
					{ class: "col" },
					h.div(
						{ class: "d-flex flex-column gap-3" },
						h.div(
							{ class: "row p-0 justify-content-between" },
							h.div(
								{
									class: "col col-auto",
									role: "button",
									onclick: h.func(
										"route.to",
										"user.view-profile",
										{
											user:
												user?.id == gc.user?.id
													? "current"
													: user?.id,
										}
									),
								},
								h.div(
									{ class: "m-0" },
									h.span(
										{ class: "fw-bold me-2" },
										user?.display_name
									),
									either(
										user?.is_business,
										() =>
											h.span(
												{ class: "text-info" },
												h.i({ class: "fas fa-shop" })
											),
										either(user?.is_verified, () =>
											h.span(
												{ class: "text-info" },
												h.i({
													class: "fas fa-circle-check",
												})
											)
										)
									)
								),

								h.div(
									{
										class: "overflow-ellipsis d-md-none m-0 form-text",
									},
									h.span(
										{ class: "text-secondary d-block" },
										"@",
										user?.username
									)
								)
							),
							h.div(
								{
									class: "col overflow-ellipsis d-none d-md-block p-0",
									role: "button",
									onclick: h.func(
										"route.to",
										"user.view-profile",
										{
											user:
												user?.id == gc.user?.id
													? "current"
													: user?.id,
										}
									),
								},
								h.span(
									{ class: "text-secondary" },
									"@",
									user?.username
								)
							),
							h.div(
								{
									class: "col col-auto p-0 position-absolute end-0 dropdown",
									role: "button",
								},
								h.MoreOptions([
									null,
									h.ul(
										{ class: "list-unstyled m-0" },

										either(
											product.owner_id == gc.user?.id,
											() =>
												h.li(
													h.div(
														{
															role: "button",
															class: "dropdown-item btn-icon-text gap-1",
															onclick:
																this.method(
																	"copyErrand",
																	[
																		product,
																		user?.id,
																	]
																),
															title: "Copy Errand",
														},
														h.span(
															{
																class: "text",
															},
															"Copy & Edit"
														),
														h.span(
															{
																class: "icon",
															},
															h.i({
																class: "fa-solid fa-copy",
															})
														)
													)
												)
										),
										either(
											product.owner_id != gc.user?.id &&
												product.is_copyable == 1,
											() =>
												h.li(
													h.div(
														{
															role: "button",
															class: "dropdown-item btn-icon-text gap-1",
															onclick:
																this.method(
																	"copyErrand",
																	[
																		product,
																		user?.id,
																	]
																),
															title: "Clone Product",
														},
														h.span(
															{
																class: "text",
															},
															"Copy & Edit"
														),
														h.span(
															{
																class: "icon",
															},
															h.i({
																class: "fa-solid fa-copy",
															})
														)
													)
												)
										),
										either(
											product.is_private == 0 ||
												(gc.user.id == user?.id &&
													product.owner_id ==
														gc.user.id &&
													product.pivot?.user_id ==
														user?.id),
											() => [
												h.li(
													h.div(
														{
															role: "button",
															class: "dropdown-item btn-icon-text gap-1",
															title: "Share on WhatsApp",
															onclick:
																this.method(
																	"shareProduct",
																	product
																),
														},
														h.span(
															{
																class: "text text-success",
															},
															"Share"
														),
														h.span(
															{
																class: "icon text-success",
															},
															h.i({
																class: "fa-brands fa-whatsapp",
															})
														)
													)
												),

												h.li(
													h.div(
														{
															role: "button",
															class: "dropdown-item btn-icon-text gap-1",
															title: "Share on WhatsApp",
															onclick:
																this.method(
																	"showQrCode",
																	product
																),
														},
														h.span(
															{ class: "text" },
															"Share (QR)"
														),
														h.span(
															{ class: "icon" },
															h.i({
																class: "fas fa-qrcode",
															})
														)
													)
												),
											]
										),

										either(
											(!route.is("user.view-cart") &&
												product.owner_id ==
													gc.user?.id &&
												product.pivot?.user_id ==
													gc.user?.id) ||
												(gc.user?.id ==
													product.pivot?.user_id &&
													gc.user?.id == user?.id &&
													product.parent_product !=
														null),
											() =>
												h.li(
													h.div(
														{
															role: "button",
															class: "dropdown-item dropdown-item-danger btn-icon-text gap-1",
															title: "Delete Errand",
															onclick:
																this.method(
																	"deleteErrand",
																	product
																),
														},
														h.span(
															{ class: "text" },
															"Delete"
														),
														h.span(
															{ class: "icon" },
															h.i({
																class: "fa-solid fa-trash-can",
															})
														)
													)
												)
										)
									),
								])
							)
						)
					)
				)
			),

			h.div(
				{ class: "d-flex flex-column mb-0" },

				h.div(
					{
						class: "fs-2 cursor-pointer d-flex gap-2 align-items-center",
						role: "button",
						onclick: h.func("route.to", "product.view-product", {
							productId: product?.id,
							u: user?.id,
						}),
					},

					h.span(
						h.img({
							width: "100%",
							height: "100%",
							style: "max-width: 35px;",
							src: `/assets/images/errands.png`,
						})
					),

					h.span(
						h.call(() =>
							either(
								product?.name == "Errand",
								product?.errand_type
									?.split("_")
									.map(
										(word) =>
											word.charAt(0).toUpperCase() +
											word.slice(1)
									)
									.join(" "),
								product?.name
							)
						)
					)
				),

				h.div(
					{ class: "d-flex gap-1 flex-column" },
					h.div({ class: "form-text" }, "Steps to Complete:"),

					h.div(
						{
							class: "d-flex overflow-auto scrollbar-sm mn-inline",
							style: "gap: 2rem; --scrollbar-margin: 1rem;",
						},
						each(product.errand_information, (task, index) =>
							h.div(
								{
									class: "bg-body-tertiary border d-flex flex-column rounded-4 flex-fill position-relative",
									style: "min-width: 250px;",
								},
								h.span(
									{
										class: "bg-white border border-3 circle position-absolute top-50 translate-middle",
										style: "--size: 2rem;",
									},
									index + 1
								),

								h.div(
									{
										class: "p-3 d-flex gap-3 pb-3 align-items-center",
									},
									h.div(
										{
											class: "d-flex gap-2 align-items-center",
										},
										h.span(
											{
												class: "circle",
												style: "--size: 30px; background-color:#ffd37e;",
											},
											h.SolidIcon("location-dot")
										),

										h.div(
											{ class: "d-flex flex-column" },

											h.span(
												{ class: "fs-xsm fw-bold" },
												"Location"
											),

											h.span(
												{
													class: "fw-bold text-primary small",
												},

												h.call(() => {
													let address = lastOf(
														task.addresses
													);

													return [
														either(
															address?.name
																?.length > 50,
															{ class: "fs-xsm" }
														),

														oneOf(
															address?.name ??
																"Anywhere"
														),
													];
												})
											)
										)
									)
								),
								h.div(
									{
										class: "d-flex flex-column border-2 rounded-bottom-4 p-3 pt-0",
									},

									either(empty(task.description), {
										class: "d-none",
									}),

									h.div(
										{
											class: "d-flex gap-2 align-items-center",
										},
										h.div(
											{ class: "bg-transparent" },
											h.span(
												{
													class: "circle text-dark",
													style: "--size: 30px; background-color:#ffd37e;",
												},
												h.SolidIcon("align-left")
											)
										),
										h.fromString(
											task.description ?? null,
											"div",
											{
												class: "text-dark text-break small mb-1",
											}
										)
									)
								)
							)
						)
					)
				),

				h.span(
					{ class: "fst-italic" },
					h.span({ class: "text-dark" }, "Carata Do"),
					h.span({ class: "text-secondary" }, " gets it done.")
				),

				either(!product?.carata_handles_delivery, () =>
					h.div(
						{},
						h.span(
							{ class: "badge bg-warning-subtle text-dark" },
							"Seller handles delivery"
						)
					)
				),

				either(!route.is("user.view-cart"), () => [
					h.div(
						{ class: "col-auto overflow-ellipsis" },
						h.span({ class: "form-text" }, product?.shared_at)
					),
					either(product?.is_copied, () =>
						h.span(
							{
								class: "text-secondary fst-italic fs-sm",
								role: "button",
								onclick: h.func(
									"route.to",
									"user.view-profile",
									{
										user:
											product?.owner?.id == gc.user?.id
												? "current"
												: product?.owner?.id,
									}
								),
							},
							"copied from @",
							product?.owner?.username
						)
					),
				]),

				either(product?.price > 0, () =>
					h.span(
						{ class: "fs-xsm" },
						"Required Fee: ",
						monetary(product?.price ?? 0)
					)
				),

				h.div(
					{
						class: "mt-2 align-items-center d-flex flex-column flex-md-row-reverse gap-2",
					},

					h.button(
						{
							class: "border btn rounded w-100 text-primary fw-500 text-uppercase",
							onclick: this.method("requestErrand", [
								product,
								user?.id,
							]),
						},
						"Request Errand"
					),
					either(
						product.owner_id != gc.user?.id &&
							product.is_copyable == 1,
						() =>
							h.button(
								{
									class: "border btn rounded w-100 text-primary fw-500 text-uppercase",
									onclick: this.method("copyErrand", [
										product,
										user?.id,
									]),
								},
								"Edit & Request"
							)
					)
				)
			),

			h.hr(),
			h.div(
				{
					class: "d-flex justify-content-between text-secondary gap-4",
				},
				h.span(
					{
						class: "d-flex gap-1 align-items-center text-danger",
					},
					either(
						product?.current_like && product?.current_like.length,
						() => [
							h.i({
								class: "fas fa-heart animated-icon animated-add",
							}),
							{ onclick: this.method("unlike", product) },
						],
						() => [
							h.i({
								class: "far fa-heart animated-icon animated-remove",
							}),
							{ onclick: this.method("like", product) },
						]
					),
					formatThousand(product?.like_count)
				),
				h.span(
					{
						class: "d-flex gap-1 align-items-center text-info-emphasis",
						onclick: this.method("comment", product),
					},
					either(
						product?.current_comment,
						() =>
							h.i({
								class: "fas fa-comment animated-icon animated-add",
							}),
						() =>
							h.i({
								class: "far fa-comment",
							})
					),
					formatThousand(product?.comment_count)
				),

				either(product?.is_saveable == 1, () =>
					h.span(
						{
							class: "d-flex gap-1 align-items-center",
							style: `color: #eea91c;`,
						},
						either(
							!(
								(product.owner_id == gc.user?.id &&
									product.pivot?.user_id == gc.user?.id) ||
								(gc.user?.id == product.pivot?.user_id &&
									gc.user?.id == user?.id &&
									product.parent_product != null) ||
								product?.copied_by_id == gc.user?.id
							),

							() =>
								either(
									product?.current_bookmark,
									() => [
										h.i({
											class: "fas fa-bookmark animated-icon animated-add",
										}),
										{
											onclick: this.method(
												"removeBookmark",
												product
											),
										},
									],
									() => [
										h.i({
											class: "far fa-bookmark animated-icon animated-remove",
										}),
										{
											onclick: this.method(
												"bookmark",
												product
											),
										},
									]
								),
							() =>
								h.i({
									class: "far fa-bookmark animated-icon animated-remove",
								})
						),

						formatThousand(product?.save_count)
					)
				),
				h.span(
					{
						class: "d-flex gap-1 align-items-center",
					},
					h.i({ class: "far fa-clipboard" }),
					formatThousand(product?.carted_count)
				)
			),
			...args
		);
	}

	deleteErrand(product) {
		broker.send($e.product.needs.deletion, payload({ id: product.id }));
	}

	shareProduct(product) {
		broker.send(
			$e.product.needs.share,
			payload({ id: product.id, product })
		);
	}

	requestErrand(product, userId) {
		product.original_product_id = product.id;
		broker.send(
			$e.errand.needs.creation,
			payload({ item: product, userId })
		);
	}

	copyErrand(product, userId) {
		product.original_product_id = product.id;
		broker.send(
			$e.errand.needs.creation,
			payload({ item: product, userId })
		);
	}

	like(product) {
		broker.send($e.product.needs.like, payload({ product }));
	}

	unlike(product) {
		broker.send($e.product.needs.unlike, payload({ product }));
	}

	bookmark(product) {
		broker.send($e.product.needs.bookmark, payload({ product }));
	}

	comment(product) {
		if (!route.is("product.view-product")) {
			setTimeout(() => {
				broker.send($e.product.needs.comment, payload({ product }));
			}, 1000);

			redirect().to("product.view-product", { productId: product.id });
			return;
		}

		broker.send($e.product.needs.comment, payload({ product }));
	}

	removeBookmark(product) {
		broker.send($e.product.needs.bookmarkRemoved, payload({ product }));
	}

	showQrCode(product) {
		broker.send(
			$e.qr.needs.code,
			payload({
				title: `${product.name} - Item QR Code`,
				data: `/products/${product?.id}/view`,
			})
		);
	}
}

ojs(MainErrandView);
